import axios from '@/utils/axios'

export const getCustomerDevelop = (payload) => {
  return axios.get('/customer_develop', {
    params: payload
  })
}

export const getCustomerDevelopById = (id, data) => {
  return axios.get(`/customer_develop/${id}`, data)
}

export const creatCustomerDevelop = (data) => {
  return axios.post(`/customer_develop/submit`, data)
}

export const customerDevelopOperate = (id, data) => {
  return axios.put(`/customer_develop/operate/${id}`, data)
}

export const deleteCustomerDevelop = (id, data) => {
  return axios.delete(`/customer_develop/${id}`, { data: { status: data } })
}